// Will be replaced by the translation keys when they exist

import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import {
  faCloud,
  faCrown,
  faGamepadModern,
  faGlobeStand,
  faHeadset,
  faTicket,
  faTickets,
  faUser,
  faUsersLine,
} from '@fortawesome/pro-solid-svg-icons';

import type { AddonType } from '~/store/support/types';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const WIKI_CARDS = [
  {
    title: 'Game Servers',
    icon: faGamepadModern,
    links: [
      {
        title: 'How private servers work for Dune: Awakening',
        link: 'https://www.g-portal.com/wiki/en/how-private-servers-work-for-dune-awakening/',
      },
      {
        title: 'How do I install mods and mod maps on my ARK server?',
        link: 'https://www.g-portal.com/wiki/en/how-do-i-install-mods-and-mod-maps-on-my-ark-server/',
      },
      {
        title: 'How do mods work in Minecraft?: How do I add Minecraft mods?',
        link: 'https://www.g-portal.com/wiki/en/how-do-mods-work-in-minecraft/#how-do-i-add-minecraft-mods',
      },
      {
        title: 'Conan Exiles – Create Backup',
        link: 'https://www.g-portal.com/wiki/en/conan-exile-create-backup/',
      },
    ],
  },
  {
    title: 'Game Cloud',
    icon: faCloud,
    links: [
      {
        title: 'How do I cancel a Gamecloud / server?',
        link: 'https://www.g-portal.com/wiki/en/how-do-i-cancel-a-server/',
      },
      {
        title: 'The GPORTAL Cloud: How do I reactivate a cancelled Gamecloud?',
        link: 'https://www.g-portal.com/wiki/en/the-gportal-cloud/#how-do-i-reactivate-a-cancelled-gamecloud',
      },
      {
        title:
          'How do I cancel a Gamecloud / server?: PC and Playstation Gamecloud / server',
        link: 'https://www.g-portal.com/wiki/en/how-do-i-cancel-a-server/#pc-and-playstation-gamecloud--server-',
      },
      {
        title: 'Tools & Tips: GPORTAL cloud',
        link: 'https://www.g-portal.com/wiki/en/tools-tips/#gportal-cloud',
      },
    ],
  },
  {
    title: 'Account',
    icon: faUser,
    links: [
      {
        title: 'How do I change my account name and/or password?',
        link: 'https://www.g-portal.com/wiki/en/how-do-i-change-my-account-name-and-or-password/',
      },
      {
        title: 'How to change email',
        link: 'https://www.g-portal.com/wiki/en/how-to-change-email',
      },
      {
        title: 'How to change username',
        link: 'https://www.g-portal.com/wiki/en/how-to-change-username',
      },
      {
        title: 'How to delete account',
        link: 'https://www.g-portal.com/wiki/en/how-to-delete-account',
      },
    ],
  },
];

export const NAV_BUTTONS = [
  {
    key: 'wiki',
    kind: 'external' as const,
    href: 'https://www.g-portal.com/wiki',
    icon: faGlobeStand,
  },
  {
    key: 'discord',
    kind: 'external' as const,
    href: 'https://discord.gg/gportal',
    icon: faDiscord,
  },
  {
    key: 'write_ticket',
    kind: 'action' as const,
    icon: faTicket,
  },
  {
    key: 'my_tickets',
    kind: 'action' as const,
    icon: faTickets,
  },
];

export const UPGRADE_OPTIONS: Array<{
  type: AddonType;
  title: string;
  icon: IconDefinition;
}> = [
  {
    type: 'standard',
    title: 'Standard',
    icon: faHeadset,
  },
  {
    type: 'priority',
    title: 'Fast lane',
    icon: faUsersLine,
  },
  {
    type: 'premium',
    title: 'Support+',
    icon: faCrown,
  },
];
